import { useState } from "react";
import {
  articlesService,
  ArticlePayload,
} from "../../../apiServices/articles.service";

export const useUpdateArticle = () => {
  const [loading, setLoading] = useState(false);

  const updateArticle = async (
    id: number,
    payload: ArticlePayload
  ) => {
    setLoading(true);

    try {
      return await articlesService.update(id, payload);
    } finally {
      setLoading(false);
    }
  };

  return {
    updateArticle,
    loading,
  };
};